import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';


export const mockInterceptor: HttpInterceptorFn = (req, next) => {
  
  // 1. Se i mock sono disabilitati, procedi normalmente verso il backend
  if (!environment?.useMocks) {
    return next(req);
  }

  // 2. Definisci la logica di mapping tra URL API e file JSON

  if (req.url.includes('/api/portale-fornitori/')) {

    let path = req.url.replace(environment.backend.baseUrl_portalefornitori+'/',"");
    let method = req.method;
    let mockfilepath = getNameFunction(path,method);
    const mockUrl = `/assets/mocks/${mockfilepath}`;

    console.warn(`[MockInterceptor]: Dirottamento da ${req.url} a ${mockUrl}`);

    // 3. Clona la richiesta cambiando l'URL e il metodo (i JSON accettano solo GET)
    const mockReq = req.clone({
      url: mockUrl,
      method: 'GET'
    });

    return next(mockReq);
  }

  return next(req);
};

export function getNameFunction(path:string,method:string){
    if(method == 'DELETE'){return 'delete.json';}
    if(method == 'GET'){
      switch(path){
        case "tp-fornitore/search":return "tpfornitore/searchquery.json";
        case "tp-articolo/search":return "tparticolo/searchquery.json";
        case "tp-asset/search":return "tpasset/searchquery.json";
        case "tp-doc-fornitore/search":return "tpdocfornitore/searchquery.json";
        case "fornitore/search":return "fornitore/searchquery.json";
        case "filiali":return "filiale/search.json";
        case "dipendenti":return "dipendente/search.json";
        case "assets":return "asset/search.json";
        case "contratto/search":return "contratto/searchquery.json";
        case "documenti":return "documento/search.json";
      }
    }
    return "";
}